import React from 'react';

interface LoadingSpinnerProps {
  text?: string;
  size?: number;
}

export function LoadingSpinner({ text = 'Wird ausgewertet...', size = 48 }: LoadingSpinnerProps) {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(10, 14, 39, 0.9)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    }}>
      <div
        style={{
          width: size,
          height: size,
          border: '4px solid rgba(255, 213, 79, 0.2)',
          borderTop: '4px solid #ffd54f',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />
      <div style={{
        marginTop: '16px',
        color: '#ffd54f',
        fontSize: '16px',
        fontWeight: 600,
      }}>
        {text}
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
